import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import { useParams } from "react-router-dom";
import { getUserById } from "../../models/UserFunctions.js"; // Function to fetch user data
import {
  getOrgById,
  getOrgByRef,
  transformUsersToTable,
} from "../../models/OrgFunctions.js"; // Functions to fetch org and client data
import Column from "../../layout/Column.js";
import Row from "../../layout/Row.js";
import Divider from "../../layout/Divider.js";
import Space from "../../layout/Space.js";
import DataGridFull from "../../tables/DataGridFull.js";
import { useTheme } from "@mui/material";
import Icon1 from "../../icons/Icon.js";
import {
  getRefFromId,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";
import TFGPT1 from "../../textfields/TFGPT1.js";
import SecondaryButton from "../../buttons/SecondaryButton.js";
import PrimaryButton from "../../buttons/PrimaryButton.js";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import { useAppContext } from "../../config/AppContext.js";
import DataGridGPT2 from "../../tables/DataGridGPT2.js";

function Users({ navigateWorkspace }) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [options, setOptions] = useState([]);

  const [selected_users_list, setSelectedUsersList] = useState([]);

  const [users, setUsers] = useState([]);
  // Function to navigateWorkspace to a client by ID
  const gotoUser = (value) => {
    navigateWorkspace(`/admin/user/${value.id}`);
  };

  // Function to navigateWorkspace to a client by name
  const gotoUserEmail = (value) => {
    // Find the client with the matching name
    const user = rows.find((row) => row.email === value.value);

    // If client exists, navigateWorkspace to the client page by ID
    if (user) {
      navigateWorkspace(`/admin/user/${user.id}`);
    } else {
      console.error("User not found");
    }
  };

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID
      const user = await getUserById(currentUser.uid);

      // Fetch organization data using the user's org reference
      const org = await getOrgById(user.org_id);

      // Fetch clients associated with the user's organization
      const users = await queryCollection("user", []);

      // Transform clients into table format (rows and columns)
      const { rows, columns } = transformUsersToTable(users);

      // Update state if the user data is new or changed
      if (user && user !== userData) {
        setUserData(user);
        setOrgData(org);
        setUsers(users);
        setRows(rows);
        setColumns(columns);

        let options_cleaned = users.map((user) => user.email);
        options_cleaned = options_cleaned.filter((user) => user !== undefined);

        // Set options for the search bar (client names)
        setOptions(
          users
            .filter((user) => user.email !== undefined)
            .map((user) => ({
              value: user.email,
              label: user.email + " " + user.display_name,
            }))
        );
      }
    }
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSetAllDenys = async () => {
    for (let user_id of selected_users_list) {
      let userRef = getRefFromId("user", user_id);
      await updateDocDataFieldApi(
        userRef,
        "beta_type",
        "denys_related",
        prefix
      );
    }
    setSelectedUsersList([]);
    handleFetchData();
  };

  const handleSetAllFake = async () => {
    for (let user_id of selected_users_list) {
      let userRef = getRefFromId("user", user_id);
      await updateDocDataFieldApi(userRef, "beta_type", "fake", prefix);
    }
    setSelectedUsersList([]);
    handleFetchData();
  };

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser || !userData) {
    return <div></div>;
  }

  const handleSelectionModelChange = (selection) => {
    setSelectedUsersList(selection);
  };

  // Render the client data
  return (
    <div className="h-full w-full max-h-full pl-4 flex-col gap-2 flex ">
      <div className="w-full h-fit flex-row  flex gap-2">
        <div className="h-fit w-full  overflow-hidden flex flex-col gap-2">
          <div className="text-hx font-medium">Utilisateurs</div>

          <div className="bg-white border-1 border-shadow_25 rounded-full w-c500 flex flex-row gap-2 items-center px-2">
            <Icon1 icon_name="search" size={20} fill="grey"></Icon1>
            <TFGPT1
              options={options}
              placeholder="Chercher"
              inputValue={searchValue}
              setInputValue={setSearchValue}
              onAction={gotoUserEmail}
              className="w-full"
              start_only={false}
            ></TFGPT1>
          </div>

          <Space y={0} />
          {selected_users_list.length > 0 && (
            <>
              <PrimaryButton onClick={handleSetAllDenys}>
                SET DENYS
              </PrimaryButton>
              <PrimaryButton onClick={handleSetAllFake}>SET Fake</PrimaryButton>
            </>
          )}

          {/* DataGrid displaying the clients */}
        </div>
      </div>{" "}
      <div className="w-full h-full max-h-full pb-40 ">
        <DataGridGPT2
          show_ranking={true}
          rows={rows}
          columns={columns}
          onClick={gotoUser}
          initial_sort_field="email"
          handleSelectionModelChange={handleSelectionModelChange}
        ></DataGridGPT2>{" "}
      </div>
    </div>
  );
}

export default Users;
